import { defaultSerializeQueryArgs } from "@reduxjs/toolkit/query";

/**
 * Sorgu önbellek anahtarından `token`ı çıkarır (#142).
 *
 * Sorgular token'ı argüman olarak alıyor (`useXQuery({ token, ... })`). Token her
 * yenilendiğinde (odak, süre sonu, 401) anahtar değişiyor ve TÜM sorgular baştan
 * çekiliyordu — sayfa yenilenmiş gibi görünüyordu. Token isteğin kimliği değil;
 * istekte her zaman güncel token kullanılır (bkz. baseQueryWithReauth).
 */
export const serializeArgsWithoutToken = ({ queryArgs, endpointDefinition, endpointName }) => {
  let args = queryArgs;
  if (args && typeof args === "object" && !Array.isArray(args) && "token" in args) {
    // eslint-disable-next-line no-unused-vars
    const { token, ...rest } = args;
    args = rest;
  }
  return defaultSerializeQueryArgs({ queryArgs: args, endpointDefinition, endpointName });
};
